'use client';

import { useEditableDotCMSPage } from '@dotcms/react';

/**
 * Wires the UVE hook for pages that don't already render a component which
 * calls useEditableDotCMSPage themselves. Mount once per page.
 *
 * Accepts a plain `pageAsset` (or a `path` shortcut for content-only routes)
 * — NEVER the full server response, since that can carry class instances
 * (e.g. DotHttpError from a failed fetch) which break RSC serialization.
 */
export function UVEBoundary({ pageAsset, path }) {
    const response =
        pageAsset != null
            ? { pageAsset }
            : path
              ? { pageAsset: { page: { pageURI: path } } }
              : null;
    useEditableDotCMSPage(response);
    return null;
}
